import styled from "styled-components";
import { AnimatePresence } from "framer-motion";
import { FC, useState } from "react";

import Button from "@/components/Button";
import { PageHeading } from "@/components/Layout/Parts";
import Text from "@/components/Text";
import BPTestingProjectsTable from "./components/BPTestingProjectsTable";
import BPTestingProjectForm from "./components/BPTestingProjectForm";
import { BPTestingProjectStatus } from "@/utils/enums";

const HeadingsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0;
`;

const NewPostButton = styled(Button)`
  padding: 0 32px;
`;

interface Props {
  status: BPTestingProjectStatus;
}

const EditorialPostsTesting: FC<Props> = ({ status }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Text $type="caption" $color="gray">
        EDITORIAL
      </Text>
      <HeadingsRow>
        <PageHeading>Posts Testing</PageHeading>
        <NewPostButton onClick={() => setShowModal(true)}>
          New project
        </NewPostButton>
      </HeadingsRow>
      <BPTestingProjectsTable status={status} />
      <AnimatePresence>
        {showModal && (
          <BPTestingProjectForm onClose={() => setShowModal(false)} />
        )}
      </AnimatePresence>
    </>
  );
};

export default EditorialPostsTesting;
